import * as tslib_1 from "tslib";
import { ElementRef, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { UsersApi as UserCoreApi } from '@api/users/users.api';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { ExportDialogComponent } from '@core/components/export-dialog/export-dialog.component';
import { ExportDialogTypeEnum } from '@core/components/export-dialog/export-dialog.types';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { merge, Subject } from 'rxjs';
import { debounceTime, switchMap, takeUntil, tap } from 'rxjs/operators';
import { DialogUsersComponent } from './dialogs/detail/dialog-users.component';
import { FilterUsersComponent } from './filter/filter-users.component';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
import { UsersApi } from './services/api/users-api.service';
import { UsersService } from './services/users-resolver.service';
var UsersComponent = /** @class */ (function () {
    function UsersComponent(fuseTranslationLoaderService, authenticationService, progressBarService, sidebarService, currentUserApi, usersService, matDialog, usersApi) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.authenticationService = authenticationService;
        this.progressBarService = progressBarService;
        this.sidebarService = sidebarService;
        this.currentUserApi = currentUserApi;
        this.usersService = usersService;
        this.matDialog = matDialog;
        this.usersApi = usersApi;
        this.loading = true;
        this.resultsLength = 0;
        this.users = [];
        this.filtered = false;
        this.displayedColumns = ['name', 'email', 'type', 'mfaEnabled', 'loginProvider', 'createdAt', 'lastLoginAt', 'edit'];
        this.usersReload = new Subject();
        this.subscriptions = new Subject();
        this.hasEditUserPermission = this.authenticationService.hasPermission('users-edit');
        this.hasCreateUserPermission = this.authenticationService.hasPermission('users-create');
        this.hasCreateExportPermission = this.authenticationService.hasPermission('exports-create');
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    UsersComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                this.sort.active = 'createdAt';
                this.sort.direction = 'desc';
                merge(this.sort.sortChange, this.paginator.page, this.filterUsersComponent.filterChanged.pipe(tap(function () { return _this.paginator.firstPage(); })), this.usersReload)
                    .pipe(debounceTime(500), takeUntil(this.subscriptions), switchMap(function () {
                    _this.sort.direction = _this.sort.direction || 'asc';
                    var options = {
                        orderBy: _this.sort.active + "_" + _this.sort.direction,
                        offset: _this.paginator.pageIndex * _this.paginator.pageSize,
                        limit: _this.paginator.pageSize
                    };
                    _this.loading = true;
                    return _this.usersService.loadData({ where: _this.filterUsersComponent.filterChanged.value, options: options });
                }))
                    .subscribe(function (result) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    var _a;
                    return tslib_1.__generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                this.datatable.nativeElement.scrollTo({
                                    top: 0,
                                });
                                _a = this;
                                return [4 /*yield*/, this.currentUserApi.me()];
                            case 1:
                                _a.currentUser = _b.sent();
                                this.users = result.items;
                                this.totalCount = result.totalCount;
                                this.filtered = result.filtered;
                                this.loading = false;
                                return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/];
            });
        });
    };
    UsersComponent.prototype.toggleFilterUsersSidebar = function () {
        this.sidebarService.getSidebar('filterUsers').toggleOpen();
    };
    UsersComponent.prototype.getUserById = function (userId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (!userId) {
                    return [2 /*return*/, {
                            name: null,
                            email: null,
                            groups: [],
                            type: 'admin',
                            role: 'default',
                            archived: false,
                            loginIntegrationEnabled: false
                        }];
                }
                return [2 /*return*/, this.usersApi.getUserById(userId).toPromise()];
            });
        });
    };
    UsersComponent.prototype.openEditDialog = function (userId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var user, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.progressBarService.show();
                        return [4 /*yield*/, this.getUserById(userId)];
                    case 1:
                        user = _a.sent();
                        this.progressBarService.hide();
                        return [4 /*yield*/, this.matDialog.open(DialogUsersComponent, {
                                panelClass: 'dialog-users',
                                data: {
                                    user: user,
                                    reloadPage: this.usersReload,
                                    isViewMode: user.name ? !this.hasEditUserPermission : false,
                                    currentUser: this.currentUser
                                }
                            })
                                .afterClosed()
                                .toPromise()];
                    case 2:
                        result = _a.sent();
                        if (result && result.reload) {
                            this.reload();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    UsersComponent.prototype.openExportDialog = function () {
        this.matDialog.open(ExportDialogComponent, {
            panelClass: 'export-dialog',
            autoFocus: false,
            data: {
                type: ExportDialogTypeEnum.users,
                limit: 10000,
                total: this.totalCount,
                where: this.filterUsersComponent.filterChanged.value
            }
        });
    };
    UsersComponent.prototype.reload = function () {
        this.usersReload.next();
    };
    UsersComponent.prototype.clearFilters = function () {
        this.filtered = false;
        this.filterUsersComponent.clearFilters();
    };
    return UsersComponent;
}());
export { UsersComponent };
